import { FunctionComponent } from "react";
import { SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import * as Styled from "./styles";

import "swiper/css";
import "swiper/css/autoplay";

type LogoSlide = {
  src: string;
  alt: string;
};

interface LogoCarouselProps {
  logos: LogoSlide[];
}

const LogoCarousel: FunctionComponent<LogoCarouselProps> = ({ logos }: LogoCarouselProps) => {
  return (
    <Styled.LogoCarouselDiv>
      <Styled.LogoCarouselSwiperWrapper>
        <Styled.SwiperDiv
          slidesPerView={3}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          speed={1000}
          loop
          onResize={() => {}}
          breakpoints={{
            767: {
              slidesPerView: 4,
            },
            1023: {
              slidesPerView: 5,
            },
            1280: {
              slidesPerView: 6,
              autoplay: false,
            },
          }}
        >
          {logos.map((logo) => (
            <SwiperSlide key={logo.alt}>
              <Styled.LogoSlideWrapper>
                <img src={logo.src} alt={logo.alt} />
              </Styled.LogoSlideWrapper>
            </SwiperSlide>
          ))}
        </Styled.SwiperDiv>
      </Styled.LogoCarouselSwiperWrapper>
    </Styled.LogoCarouselDiv>
  );
};

export default LogoCarousel;
